import { render, staticRenderFns } from "./bindEntity.vue?vue&type=template&id=033ff6b0"
import script from "./bindEntity.vue?vue&type=script&lang=js"
export * from "./bindEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports